import { isTransportError, useOpenWindow } from '@krp/client-runtime'
import { skipToken } from '@reduxjs/toolkit/query'
import { CashReceiptLines, ONEC_WINDOWS, onecCashReceipt, onecProductPhotoUrl } from '@krp/resource-onec-ui'

/**
 * Товары чека 1С под раскрытой строкой списка: тот же запрос чека, что у окна чека (`onecCashReceipt`), поэтому «Подробнее» после
 * раскрытия открывается без второго чтения. Товар открывает карточку 1С поверх экрана; при неизвестном виде чек не читается.
 */
export function CashReceiptLinesBinding({ resourceId, kind, receiptKey }: { resourceId: string; kind: string | undefined; receiptKey: string }) {
  const open = useOpenWindow()
  const query = onecCashReceipt.useQuery(kind === 'sale' || kind === 'refund' ? { resourceId, kind, key: receiptKey } : skipToken)
  return <CashReceiptLines data={query.currentData?.data}
    error={query.isError ? isTransportError(query.error) ? query.error.message : 'Не удалось прочитать исходный чек' : null}
    openProduct={(key) => open(ONEC_WINDOWS.product, { rid: resourceId, key })} photoOf={(key) => onecProductPhotoUrl(resourceId, key)} />
}
